"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORT_SEARCH_SHARD_COUNT = exports.REPORT_SEARCH_COLLECTION = void 0;
exports.getReportSearchKey = getReportSearchKey;
exports.getReportSearchShardId = getReportSearchShardId;
exports.toReportSearchEntry = toReportSearchEntry;
exports.isSameReportSearchEntry = isSameReportSearchEntry;
// Full report docs carry their whole content, so reading every report to search them never
// finishes at prod scale. A trigger keeps this slim copy in a few shard docs instead; see
// adr/global-search-report-index.md. Shard docs cap at 1 MiB, so raise the count before
// entries * ~280 B / shards approaches that.
exports.REPORT_SEARCH_COLLECTION = 'report_search';
exports.REPORT_SEARCH_SHARD_COUNT = 16;
function getReportSearchKey(type, id) {
    return `${type}_${id}`;
}
function getReportSearchShardId(key) {
    let hash = 0;
    for (const char of key)
        hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
    return `shard-${String(hash % exports.REPORT_SEARCH_SHARD_COUNT).padStart(2, '0')}`;
}
function text(value) {
    return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}
function millis(value) {
    if (typeof value === 'number')
        return value;
    if (value instanceof Date)
        return value.getTime();
    if (value && typeof value.toMillis === 'function') {
        return value.toMillis();
    }
    if (typeof value === 'string') {
        const parsed = Date.parse(value);
        return Number.isNaN(parsed) ? undefined : parsed;
    }
    return undefined;
}
/** Null means the report must not be in the index (missing or trashed). */
function toReportSearchEntry(type, id, data) {
    if (!data || data.deletedAt)
        return null;
    const entry = {
        id,
        type,
        customer_name: text(data.customer_name),
        customer_phone: text(data.customer_phone),
        customer_address: text(data.customer_address),
        header: text(data.header),
        createdAt: millis(data.createdAt),
        userId: text(data.userId),
    };
    return Object.fromEntries(Object.entries(entry).filter(([, value]) => value !== undefined));
}
// Entries are built in a fixed key order, so JSON equality is exact.
function isSameReportSearchEntry(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}
